/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import ArticlesContainer from './articles/container/ArticlesContainer';

function NewsContainer({ match }) {
  return (
    <Switch>
      <Route
        exact
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/articles`} />}
      />
      <Route path={`${match.path}/articles`} component={ArticlesContainer} />
    </Switch>
  );
}

NewsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(NewsContainer);
